import React, { useEffect, useState, forwardRef } from 'react';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment-timezone';
import { dateFormat, capitalizeWords, capitalizeFirstLetter } from "../../utils";
//import { useSelector } from 'react-redux';

const TripPDF = forwardRef(({ details, myArray }, ref) => {
  //const [details, setDetails] = useState(null);
  const [appointmentTime, setAppointmentTime] = useState('');
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('userData')));
  const [tripPickupTime, setTripPickupTime] = useState();

  useEffect(() => {
    if (details && myArray && myArray[details.schedule_id]) {
      const firstLeg = myArray[details.schedule_id][0];
      setAppointmentTime(firstLeg?.pick_up_time);
      const rawPick = firstLeg?.trip?.pick_up_time;
      setTripPickupTime(
        rawPick && rawPick !== 'Will Call'
          ? moment(rawPick, 'HH:mm:ss').format('hh:mm A')
          : rawPick || ''
      );
    }
  }, [details, myArray]);

  const formatFullAddress = (address) => {
    if (address == null) return "";
    const s = String(address).trim();
    return s || "N/A";
  };
  // const generatePDF = () => {
  //   const input = document.getElementById('pdf-content');
  //   html2canvas(input, { scale: 2, useCORS: true }).then((canvas) => {
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     const imgWidth = 210; // A4 width in mm
  //     const pageHeight = 297; // A4 height in mm
  //     const padding = 10; // Padding in mm
  //   const contentWidth = imgWidth - padding * 2; // Content width with padding
  //   const imgHeight = (canvas.height * contentWidth) / canvas.width;
  //   let heightLeft = imgHeight;
  //   let position = 0;

  //   pdf.addImage(imgData, 'PNG', padding, position, contentWidth, imgHeight);
  //   heightLeft -= pageHeight;

  //   while (heightLeft >= 0) {
  //     position = heightLeft - imgHeight;
  //     pdf.addPage();
  //     pdf.addImage(imgData, 'PNG', padding, position, contentWidth, imgHeight);
  //     heightLeft -= pageHeight;
  //   }
  //     pdf.save(`Trip_Details_${details.schedule_id}.pdf`);
  //   });
  // };

  if (!details) return <div>Loading...</div>;

  const legsForPdf = myArray?.[details.schedule_id];
  const firstTripLeg = legsForPdf?.[0]?.trip;
  const vehicleInfo = details?.vehicle || firstTripLeg?.vehicle;
  const tripDateDisplay = dateFormat(details?.trip_date || details?.schedule_date);
  const plateDisplay =
    vehicleInfo?.license_plate_type ||
    vehicleInfo?.license_plate ||
    vehicleInfo?.vehicle_number ||
    '—';

  return (
    <>
      {/* <div> */}
      <div ref={ref} id="pdf-content">

        <Table border={1} cellPadding={0} cellSpacing={0} style={{ width: '100%', border: 'none', fontSize: '20px' }}>
          <thead>
            <tr><td colspan={4} style={{ border: 'none', borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none' }}></td></tr>
            <tr style={{ textAlign: 'center' }}>
              <td colSpan={4} style={{ border: 'none', borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none' }}>
                <h3 style={{ margin: '0px' }}>{capitalizeWords(userData.full_name) + " ," + capitalizeWords(userData.agency_id)}</h3>
                <p style={{ margin: '0px', fontSize: '20px' }}>{capitalizeFirstLetter(userData.address1)}</p>
                <p style={{ margin: '0px', fontSize: '20px' }}>{capitalizeFirstLetter(userData.address2)}</p>
                <p style={{ margin: '0px', fontSize: '20px' }}>{capitalizeFirstLetter(userData.city) + " , " + capitalizeFirstLetter(userData.state_master_list.state_name) + " , " + userData.zip}</p>
                <p style={{ margin: '0px', fontSize: '20px' }}>Telephone : {userData.mobile_no}</p>
                <p style={{ margin: '0px', fontSize: '20px' }}>{"Email : " + capitalizeFirstLetter(userData.user_email)}</p>
              </td>
            </tr>
            <tr><td colspan={4} style={{ border: 'none', borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none' }}></td></tr>

          </thead>
          <tbody>
            <tr style={{ textAlign: 'center' }}>
              <td colspan={4} style={{ border: 'none', borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none' }}>
                <p style={{ fontStyle: 'italic', margin: '0px', fontSize: '20px' }}>This form is to be filled out for each trip assigned</p>
              </td>
            </tr>
            <tr>
              <td colSpan={3} style={{ border: 'solid 1px #333', fontSize: '20px' }}><strong>Recipient Name :</strong> {details?.passengerDetails ? " " +
                `${details.passengerDetails.passengerFirstName} ${details.passengerDetails?.passengerMiddleName || ''} ${details.passengerDetails.passengerMiddleName}` : ''}</td>
              <td style={{ border: 'solid 1px #333', fontSize: '20px' }}><strong>Member ID :</strong> {details?.passengerDetails?.passenger?.pass_pmi_no}</td>
            </tr>
            <tr>
              <td style={{ border: 'solid 1px #333', fontSize: '20px' }}><strong>NPI</strong></td>
              <td style={{ border: 'solid 1px #333', fontSize: '20px' }}><strong>Appointment Time  :</strong> {appointmentTime} </td>
              <td style={{ border: 'solid 1px #333', fontSize: '20px' }}><strong>Pick Up Time :</strong> {tripPickupTime}</td>
              <td style={{ border: 'solid 1px #333', fontSize: '20px' }}><strong>Trip Date :</strong> {tripDateDisplay}</td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: 'solid 1px #333', fontSize: '20px' }}><strong>Driver Name :</strong> {(details?.driverDetails?.firstName && details?.driverDetails?.lastName)
                ? (details.driverDetails.firstName + " " + (details.driverDetails?.middleName ?? '') + " " + details.driverDetails.lastName)
                : details?.driverDetails?.fullName || ''}</td>
              <td style={{ border: 'solid 1px #333', fontSize: '20px' }}><strong>Scheduled Miles :</strong> {details?.scheduled_miles ?? 'N/A'}</td>
              <td style={{ border: 'solid 1px #333', fontSize: '20px' }}><strong>Driver ID :</strong> {(details?.driverDetails?.driverId)}</td>
            </tr>
            <tr><td colspan={4} style={{ border: 'none', borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none' }}></td></tr>
            <tr>
              <td colSpan={4} style={{ padding: '0px', borderBottom: 'solid 1px #333', fontSize: '20px' }}>I certify that this tripsheet is an accurate account on the miles I actually drove, on the dates and at the times stated</td>
            </tr>
            <tr>
              <td colSpan={3} style={{ border: 'solid 1px #333', fontSize: '20px' }}><strong>Driver Signature : </strong>
                {myArray && myArray[details.schedule_id] && myArray[details.schedule_id][0]?.driver_signature_file ?
                  <img src={process.env.REACT_APP_API_BASE_URL + '/responses' + '/uploads/' + details.comp_id + '/' + 'signature' + '/driver/' + myArray[details.schedule_id][0].schedule_trans_id + '/' + myArray[details.schedule_id][0].driver_signature_file}
                    alt={`Driver Signature`}
                    style={{
                      width: '80px',
                      height: '50px',
                      objectFit: 'contain',
                      margin: '5px'
                    }}
                  />
                  : ''}
              </td>
              <td style={{ border: 'solid 1px #333', fontSize: '20px' }}><strong>Date :</strong> {tripDateDisplay}</td>
            </tr>
            {myArray && myArray[details.schedule_id] && myArray[details.schedule_id].map((leg, legIndex) => {
              const pickupAddressFull = formatFullAddress(leg.trip?.pickup_location);
              const dropoffAddressFull = formatFullAddress(leg.trip?.dropOffLocation);
              // Miles Traveled: prefer odometer delta (End − Start); fallback to scheduled miles + dead head on leg 1
              const startOdRaw = leg?.trip?.startOdometer;
              const endOdRaw = leg?.trip?.endOdometer;
              const startOd =
                startOdRaw !== null && startOdRaw !== undefined && String(startOdRaw).trim() !== ''
                  ? Number(startOdRaw)
                  : NaN;
              const endOd =
                endOdRaw !== null && endOdRaw !== undefined && String(endOdRaw).trim() !== ''
                  ? Number(endOdRaw)
                  : NaN;
              let milesTraveled;
              if (Number.isFinite(startOd) && Number.isFinite(endOd)) {
                milesTraveled = Math.max(0, Math.round(endOd - startOd));
              } else {
                const legMiles = Number(leg?.trip?.miles) || 0;
                const deadHead = legIndex === 0 ? (Number(details?.dead_head_miles) || 0) : 0;
                milesTraveled = Math.round(legMiles + deadHead);
              }
              return (
                <React.Fragment key={legIndex}>
                  {/* {legArray.map((leg, legIndex) => { */}



                  {/* <React.Fragment key={legIndex}> */}
                  <tr><td colspan={4} style={{ border: 'none', borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none' }}></td></tr>
                  <tr> <td style={{ textAlign: 'center', border: 'none', borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none', width: '10%', fontSize: '20px' }}><strong>Leg {legIndex + 1}</strong></td>

                    <td style={{ border: '1px solid #333', position: 'relative', borderTop: '1px solid #333', width: '25%', fontSize: '20px' }}><strong>Actual Pick Up Time :</strong> {leg.trip?.pick_up_time ? moment(leg.trip?.pick_up_time, 'HH:mm:ss').format('hh:mm') : ''}
                      <span style={{ position: 'absolute', top: '0px', right: '10px', margin: '2px' }}>AM
                        <input type="checkbox" checked={leg.trip?.pick_up_time && moment(leg.trip?.pick_up_time, 'HH:mm:ss').format('A') === 'AM'} readOnly />
                      </span>
                      <span style={{ position: 'absolute', top: '20px', right: '10px', margin: '2px' }}>PM
                        <input type="checkbox" checked={leg.trip?.pick_up_time && moment(leg.trip?.pick_up_time, 'HH:mm:ss').format('A') === 'PM'} readOnly />
                      </span>
                    </td>
                    <td colSpan={2} style={{ border: '1px solid #333', borderTop: '1px solid #333', width: '65%', wordBreak: 'break-word', whiteSpace: 'normal', fontSize: '20px' }}><strong>Actual Pickup Address :</strong> {pickupAddressFull}</td>
                  </tr>
                  <tr>
                    <td style={{ border: 'none', borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none' }}>&nbsp;</td>
                    <td style={{ border: '1px solid #333', borderWidth: '1px solid #333', position: 'relative', width: '25%', fontSize: '20px' }}><strong>Actual Drop Off Time  :</strong> {leg.trip?.drop_off_time ? moment(leg.trip?.drop_off_time, 'HH:mm:ss').format('hh:mm') : ''}
                      <span style={{ position: 'absolute', top: '0px', right: '10px', margin: '2px' }}>AM
                        <input type="checkbox" checked={leg.trip?.drop_off_time && moment(leg.trip?.drop_off_time, 'HH:mm:ss').format('A') === 'AM'} readOnly />
                      </span>
                      <span style={{ position: 'absolute', top: '20px', right: '10px', margin: '2px' }}>PM
                        <input type="checkbox" checked={leg.trip?.drop_off_time && moment(leg.trip?.drop_off_time, 'HH:mm:ss').format('A') === 'PM'} readOnly />
                      </span>
                    </td>
                    <td colSpan={2} style={{ border: '1px solid #333', borderWidth: '1px solid #333', wordBreak: 'break-word', whiteSpace: 'normal', width: '65%', fontSize: '20px' }}><strong>Actual Drop Off Address :</strong> {dropoffAddressFull}</td>
                  </tr>
                  <tr>
                    <td style={{ border: 'none', borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none' }}>&nbsp;</td>
                    <td colSpan={2} style={{ border: '1px solid #333', borderWidth: '1px solid #333', fontSize: '20px' }}><strong>Client Signature :</strong>
                      {leg.signature_file ? <img src={process.env.REACT_APP_API_BASE_URL + '/responses' + '/uploads/' + details.comp_id + '/' + 'signature' + '/passenger/' + leg.schedule_trans_id + '/' + leg.signature_file}
                        alt={`Signature for Leg ${legIndex + 1}`}
                        style={{
                          width: '80px',
                          height: '50px',
                          objectFit: 'contain',
                          margin: '5px'
                        }}
                      />
                        : ''}
                    </td>
                    <td style={{ border: '1px solid #333', borderWidth: '1px solid #333' }}>

                      <p style={{ margin: '0px', fontSize: '20px' }}><strong>Odometer Reading : </strong>{`Start — ${leg.trip?.startOdometer ?? 'N/A'}  End — ${leg.trip?.endOdometer ?? 'N/A'}`}</p>
                      <p style={{ margin: '0px', fontSize: '20px' }}><strong>Miles Traveled: </strong>{milesTraveled}</p>
                    </td>
                  </tr>
                  <tr>
                    {/* <td >&nbsp;</td> */}
                    <td colSpan={4} style={{ border: 'none', borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none' }} ></td>
                  </tr>
                  {/* </React.Fragment> */}
                  {/* )})} */}
                </React.Fragment>
              )
            })}

            <tr>
              <td colSpan={3} style={{ padding: '0px', borderBottom: 'solid 1px #333' }}> I certify that I received the reported transportation service </td>
              <td style={{ textAlign: 'center', padding: '0px', borderBottom: 'solid 1px #333' }}> <strong>Payer Type</strong></td>
            </tr>
            <tr>
              <td colSpan={2} style={{ borderBottom: 'solid 1px #333', border: 'solid 1px #333', width: '50%' }}><strong>Notes (Facility Stamp)</strong></td>
              <td colSpan={2} style={{ borderBottom: 'solid 1px #333', borderRight: 'solid 1px #333', width: '50%' }}><strong>MA STS</strong> </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: '1px solid #333', height: '5em' }}>{details?.schedule_note}</td>
              <td colSpan={2} style={{ border: '1px solid #333', height: '5em' }}> </td>
            </tr>
            <tr><td colspan={4} style={{ border: 'none', borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none' }}></td></tr>
            <tr>
              <td colSpan={4} style={{ padding: '0px' }}><strong>Vehicle Information, If Applicable</strong></td>
            </tr>
            <tr style={{ padding: '0 px' }}>
              <td colSpan={4} style={{ padding: '0px' }}>
                <table style={{ width: '100%' }}>
                  <tbody>
                    <tr>
                      <th style={{ width: '25%', border: '1px solid #333' }}>MAKE</th>
                      <th style={{ width: '25%', border: '1px solid #333' }}>MODEL</th>
                      <th style={{ width: '25%', border: '1px solid #333' }}>YEAR</th>
                      <th style={{ width: '25%', border: '1px solid #333' }}>PLATE #</th>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid #333', fontWeight: '200', fontSize: '20px' }}>{vehicleInfo?.vehicle_make || '—'}</td>
                      <td style={{ border: '1px solid #333', fontWeight: '200', fontSize: '20px' }}>{vehicleInfo?.vehicle_model || '—'}</td>
                      <td style={{ border: '1px solid #333', fontWeight: '200', fontSize: '20px' }}>{vehicleInfo?.model_year || '—'}</td>
                      <td style={{ border: '1px solid #333', fontWeight: '200', fontSize: '20px' }}>{plateDisplay}</td>
                    </tr>
                    <tr>
                      <th colSpan={2} style={{ border: '1px solid #333', fontSize: '20px' }}>START ODOMETER</th>
                      <th colSpan={2} style={{ border: '1px solid #333', fontSize: '20px' }}>END ODOMETER</th>
                    </tr>
                    <tr>
                      <td colSpan={2} style={{ border: '1px solid #333', fontSize: '20px' }}>{firstTripLeg?.startOdometer != null && String(firstTripLeg.startOdometer).trim() !== '' ? firstTripLeg.startOdometer : '—'}</td>
                      <td colSpan={2} style={{ border: '1px solid #333', fontSize: '20px' }}>{firstTripLeg?.endOdometer != null && String(firstTripLeg.endOdometer).trim() !== '' ? firstTripLeg.endOdometer : '—'}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
      <div className='footer-content' style={{ display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>
        <Button style={{ backgroundColor: '#f9ae3b', borderRadius: '0px', width: '9em' }} variant="secondary" onClick={() => window.close()}>
          Close
        </Button>
        {/* <Button style={{backgroundColor:'#328277',marginLeft:'5px',borderRadius:'0px'}} variant="primary" onClick={generatePDF}>
              Download PDF
          </Button> */}
      </div>
      {/* </div> */}

    </>


  )
});

export default TripPDF